<template>
  <date-picker
    lang="en"
    :format="userDateFormat"
    :value-type="backendDateFormat"
    :confirm="false"
    :value="value"
    prefix-class="xmx"
    :name="field.name"
    v-validate="{required: required && !field.hide}"
    :data-vv-as="field.description"
    :placeholder="userDateFormat"
    :input-attr="{name: field.name, id: 'dp-'+field.name}"
    :disabled="locked"
    @input="$emit('input', $event)"
  />
</template>

<script>
import DatePicker from 'vue2-datepicker';
import { DATE_TYPE } from "../../../enums/dateType";
import { computed, getCurrentInstance } from 'vue'

export default {
  props: {
    value: {
      type: String,
      required: false
    },
    field: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: false,
    },
    locked: {
      type: Boolean,
      default: false,
    }
  },
  components: {DatePicker},
  emits: ['input'],

  setup() {
    const root = getCurrentInstance();

    // TODO: change to useStore after upgrade to Vue 3
    const userDateFormat = computed(() => root.proxy.$store.getters.getUser && root.proxy.$store.getters.getUser.date_format || 'MM/DD/YYYY');

    return {
      userDateFormat,
      backendDateFormat: DATE_TYPE.BACKEND,
    }
  }
}
</script>



// WEBPACK FOOTER //
// DateRender.vue?2e42af70